import * as React from "react";
import history from "script/history";

//import Scss
import "./assets/scss/themes.scss";

//imoprt Route
import Route from "./Routes";

function App() {

  return (
    <React.Fragment>
      <Route history={history}/>
    </React.Fragment>
  );
}

export default App;
